import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // Makes the service available throughout the app
})
export class TermsModal {
  // Tracks whether the modal is open
  modalState = new BehaviorSubject<boolean>(false);
  modalState$ = this.modalState.asObservable();

  // Tracks whether terms have been accepted
  termsAccepted = new BehaviorSubject<boolean>(false);
  termsAccepted$ = this.termsAccepted.asObservable();

  // Open the modal
  openModal() {
    this.modalState.next(true);
  }

  // Close the modal
  closeModal() {
    this.modalState.next(false);
  }

  // Accept terms
  acceptTerms() {
    this.termsAccepted.next(true);
    this.closeModal();
  }
}
